export const LobbyFirmLobbyingCommunications = (
    <div className="flex flex-col gap-2">
        <div>
            This exhibit breaks down lobby-firm communication filings over
            the last 12 months along three dimensions
        </div>
    </div>
);
